import gql from "graphql-tag";

export const GET_OPEN_REQUEST_APPROVALS_WO_EXAMINER_LIST = gql`
  query notApprovedListWoExaminer {
    notApprovedListWoExaminer {
      employeeName
      contractCode
      orgUnit
      _id
    }
  }
`;
